// client/src/components/public/PublicHeader.js
import React, { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';

const PublicHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);

    const activeLinkStyle = {
        color: '#4f46e5', // indigo-600
        fontWeight: '600',
    };
    
    const closeMenu = () => setIsMenuOpen(false);

    // "List your property" shows only while owner listings are switched on for this site.
    const [ownersOpen, setOwnersOpen] = useState(false);
    useEffect(() => {
        let live = true;
        fetch('/api/public/owner-listings/config')
            .then((r) => (r.ok ? r.json() : null))
            .then((c) => { if (live) setOwnersOpen(!!(c && c.enabled)); })
            .catch(() => {});
        return () => { live = false; };
    }, []);

    return (
        <header className="bg-white/95 backdrop-blur-sm shadow-sm sticky top-0 z-50">
            <nav className="container mx-auto px-6 py-4 flex justify-between items-center">
                <Link to="/" className="text-2xl font-bold text-slate-800" onClick={closeMenu}>
                    Business Real Estate Corp.
                </Link>

                {/* Desktop Menu (Hidden on mobile) */}
                <div className="hidden md:flex items-center md:space-x-5 lg:space-x-8">
                    <NavLink to="/" style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="text-slate-600 hover:text-indigo-600 transition-colors">Home</NavLink>
                    <NavLink to="/about" style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="text-slate-600 hover:text-indigo-600 transition-colors">About</NavLink>
                    <NavLink to="/properties" style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="text-slate-600 hover:text-indigo-600 transition-colors">Properties</NavLink>
                    <NavLink to="/office-registry" style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="text-slate-600 hover:text-indigo-600 transition-colors">Our Agents</NavLink>
                    <NavLink to="/work-with-us" style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="text-slate-600 hover:text-indigo-600 transition-colors whitespace-nowrap">Join Us</NavLink>
                    <NavLink to="/contact" style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="text-slate-600 hover:text-indigo-600 transition-colors">Contact</NavLink>
                    {ownersOpen && (
                        <Link to="/list-your-property" className="whitespace-nowrap px-5 py-2.5 text-base lg:text-lg font-extrabold uppercase tracking-wide text-slate-900 bg-amber-400 rounded-md hover:bg-amber-300 shadow-md ring-2 ring-amber-500 transition-all">
                            List Your Property
                        </Link>
                    )}
                    <Link to="/portal" className="px-5 py-2 text-white font-semibold bg-slate-800 rounded-md hover:bg-slate-900 shadow-sm transition-all">
                        Secure Portal
                    </Link>
                </div>

                {/* Hamburger Menu Button (Visible on mobile) */}
                <div className="md:hidden">
                    <button onClick={() => setIsMenuOpen(!isMenuOpen)} className="text-slate-800 focus:outline-none" aria-label="Toggle menu">
                        {/* CORRECTED SVG viewBox and path */}
                        <svg className="h-6 w-6" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                            {isMenuOpen ? (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                            ) : (
                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
                            )}
                        </svg>
                    </button>
                </div>
            </nav>

            {/* Mobile Menu Panel (Shown/hidden based on state) */}
            <div className={`md:hidden ${isMenuOpen ? 'block' : 'hidden'}`}>
                <div className="px-2 pt-2 pb-3 space-y-1 sm:px-3 text-center">
                    <NavLink to="/" onClick={closeMenu} style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="block px-3 py-2 rounded-md text-base font-medium text-slate-600 hover:bg-slate-100">Home</NavLink>
                    <NavLink to="/about" onClick={closeMenu} style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="block px-3 py-2 rounded-md text-base font-medium text-slate-600 hover:bg-slate-100">About</NavLink>
                    <NavLink to="/properties" onClick={closeMenu} style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="block px-3 py-2 rounded-md text-base font-medium text-slate-600 hover:bg-slate-100">Properties</NavLink>
                    <NavLink to="/office-registry" onClick={closeMenu} style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="block px-3 py-2 rounded-md text-base font-medium text-slate-600 hover:bg-slate-100">Our Agents</NavLink>
                    <NavLink to="/work-with-us" onClick={closeMenu} style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="block px-3 py-2 rounded-md text-base font-medium text-slate-600 hover:bg-slate-100">Join Us</NavLink>
                    <NavLink to="/contact" onClick={closeMenu} style={({ isActive }) => isActive ? activeLinkStyle : undefined} className="block px-3 py-2 rounded-md text-base font-medium text-slate-600 hover:bg-slate-100">Contact</NavLink>
                    {ownersOpen && (
                        <Link to="/list-your-property" onClick={closeMenu} className="block w-3/4 mx-auto mt-4 px-5 py-3 text-lg font-extrabold uppercase tracking-wide text-slate-900 bg-amber-400 rounded-md hover:bg-amber-300 shadow-md ring-2 ring-amber-500">
                            List Your Property
                        </Link>
                    )}
                    <Link to="/portal" onClick={closeMenu} className="block w-3/4 mx-auto mt-4 px-5 py-2 text-white font-semibold bg-slate-800 rounded-md hover:bg-slate-900 shadow-sm">
                        Secure Portal
                    </Link>
                </div>
            </div>
        </header>
    );
};

export default PublicHeader;